// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__234UY","content":"ManualTimeModal_content__2fuC2"};